<template>
  <div class="w-full h-full overflow-hidden">
    <column-header :title="title" :showMore="false" v-if="showTitle" />
    <div
      class="w-full  flex justify-between items-center"
      :class="showTitle ? 'h-[calc(100%-38px)]' : 'h-full'"
    >
      <div class="flex-1 h-full overflow-hidden">
        <el-carousel
          ref="nop"
          :interval="5000"
          trigger="click"
          indicator-position="none"
          :arrow="'never'"
          height="100%"
          :autoplay="false"
        >
          <el-carousel-item v-for="(items, i) in carouselList" :key="i">
            <div
              class="inline-flex justify-center items-center relative cursor-pointer px-10px"
              :class="filterWidth()"
              v-for="(item, index) in items"
              :key="index"
              :style="{ width: `calc(100% /${data.colNum > 1 ? data.colNum : 1}` }"
              @click="toHref(item)"
            >
              <span
                class="text-14px color-hex-333333 max-w-190px overflow-hidden text-center truncate"
                >{{ item.title }}</span
              >
              <img
                src="http://diycode04.wiz.top:9010/huizhou-public/huarun/img/20231025/frame.png"
                class="w-12px h-12px"
                alt=""
                srcset=""
              />
              <span
                class="w-2px h-14px bg-hex-D71318 rounded-10px absolute right-0"
                v-if="
                  index !== colNum - 1 && index !== colNum * 2 - 1 && index !== items.length - 1
                "
              ></span>
            </div>
          </el-carousel-item>
        </el-carousel>
      </div>
    </div>
  </div>
</template>

<script>
import { ColumnTableApi } from '@wiz-api/workbench-std'
import addRequestQueue from '@/assets/js/RequestQueue'
import ColumnHeader from './ColumnHeader'

const columnTableApi = new ColumnTableApi()
export default {
  props: {
    data: {
      type: Object,
      default: () => {
        return {}
      },
    },
    mode: {
      type: String,
      default: '',
    },
  },
  components: {
    ColumnHeader,
  },
  watch: {
    data: {
      immediate: true,
      deep: true,
      handler(val, oldVal) {
        if (!_.isEmpty(val)) {
          this.showTitle = val.showTitle
          if (val.title) this.title = val.title
          this.colNum = val.colNum
          this.filterWidth()
          if (val.dataSource && val.dataSource !== oldVal?.dataSource) {
            this.getCompentsData(val.dataSource, val.pageSize, val.colNum)
          }
        }
      },
    },
    urlList: {
      immediate: true,
      handler(val) {
        if (val && val.length > this.colNum * 2) {
          const row = Math.ceil(val.length / (this.colNum * 2))
          this.carouselList = []
          for (let i = 0; i < row; i += 1) {
            this.carouselList[i] = []
            for (let j = 0; j < this.colNum * 2; j += 1) {
              const index = i * this.colNum * 2 + j
              if (index < val.length) {
                this.carouselList[i][j] = val[index]
              }
            }
          }
        } else {
          this.carouselList = []
          this.carouselList.push(val)
        }
      },
    },
  },
  data() {
    return {
      carouselList: [],
      urlList: [],
      colNum: 5,
      showTitle: true,
      title: '友情链接',
    }
  },
  methods: {
    async getCompentsData(id, pageSize, col) {
      const param = {
        columnId: id,
        isShow: true,
      }
      const [err, res] = await addRequestQueue(() => {
        return columnTableApi.getLinkColumnTable(1, pageSize * col, param)
      })
      if (!err && res) {
        this.urlList = res.items
      }
    },
    filterWidth() {
      let str = ''
      this.urlList.length > this.data.colNum ? (str = `${str} h-1/2`) : (str = `${str} h-full`)
      return str
    },
    toHref(row) {
      if (this.mode === 'view') {
        row.skipMode === 1 ? window.open(row.url) : (window.location.href = row.url)
      }
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep .el-carousel {
  height: 100%;
}
.link-title {
  white-space: nowrap;
  text-overflow: ellipsis;
}
</style>
